import React, { useRef, useState, useEffect } from "react";
import CallIcon from "@mui/icons-material/Call";
import cssClasses from "../AllAllotments.module.css";
import { Box, Card, CardActions, Checkbox, Grid, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import {
	getParkingSelectionCrmAllotments,
	getCRMTimelineData,
	updateParkingSelectionFlag,
	sendWelcomePdf,
	fetchParkingData,
	insertCRMLogs,
	getAggrementId,
	getApplicantId,
	getVirtualAccDetailsById,
} from "../../../Services/AllAllotments";
import { errorTost, successTost } from "../../../Services/Toast";
import useAlertModal from "../../../Subcomponents/useAlertModal";
import { moveToChangeAVViaApi } from "../../../Services/PaymentApi";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";
import { makeStyles } from "@mui/styles";
import ReactTimeAgo from "react-time-ago";
import Button from "../../../Subcomponents/Button";
import _, { debounce } from "lodash";
import SearchBar from "../../../Subcomponents/Search";
import AllotmentFilter from "./AllotmentFilter";
import ViewToggleSwitch from "../../../Subcomponents/ViewSwitch/ViewToggleSwitch";
import AllotmentSortFilter from "./AllotmentSortFIlter";
import EmptyState from "../../../Assets/Images/Common/noProjectFound.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import ServerPaginationGrid from "../../ServerPaginationGrid";
import { supabase } from "../../../supabaseClient";
import ConfirmationAlert from "../../../Subcomponents/ConfirmationAlert";
import ViewAllotedCrmDetailsModal from "./ViewAllotedCrmDetailsModal/ViewAllotedCrmDetailsModal";
import SelectParkingModal from "./SelectParkingModal/SelectParkingModal";
import infoSvg from "../../../Assets/Images/Common/info.svg";
import ViewDocumentsModal from "./ViewDocumentsModal/ViewDocumentsModal";
import EnterEmailModal from "./EnterEmailModal/EnterEmailModal";
import CrmTimeLineModal from "./CRMTimeLineModal/CrmTimeLineModal";
import PreviewAggrementConfirmationModal from "./PreviewAggrementConfirmationModal/PreviewAggrementConfirmationModal";
import UpdateLeadDetails from "./CheckVirtualAccountStatus/CheckVirtualAccountStatus";
import { getLeadVirtualAccountStatus } from "../../../Services/Lead";
import CancelUnit from "../../../Modals/CancelUnit.js/CancelUnit";
import SelectCrmUserModal from "../SelectCrmUserModal/SelectCrmUserModal";
import { getCRMUsersFromUserTable } from "../../../Services/Users";
const useStyles = makeStyles((theme) => ({
	Grid: {
		"&.MuiGrid-item": {
			padding:
				window.innerWidth < 820
					? "10px 1px !important"
					: "1px 0rem 2.4rem 2.4rem !important",
		},
	},
	Tabs: {
		"&.MuiTabPanel-root": {
			padding: "1rem 0rem 2rem 0rem !important",
		},
	},
}));

function ParkingSelection() {
	const classes = useStyles();

	const loggedInUser = useSelector((state) => state.Auth.user);
	const [allCrmAllotments, setAllCrmAllotments] = useState([]);
	const hasMore = useRef(true);
	const pageNumber = useRef(0);
	const searchValue = useRef("");
	const [mode, setMode] = useState("Card View");
	const [selectedAllotmentForViewCrmDetails, setSelectedAllotmentForViewCrmDetails] = useState(null);
	const [emailSentCount, setEmailSentCount] = useState(0);
	const [checked, setChecked] = React.useState([]);
	const [filterBy, setFilterBy] = useState("Latest First");
	const [selectDates, setSelectDates] = useState([
		{ label: "StartDate", value: "" },
		{ label: "EndDate", value: "" },
	]);
	const [depStr, setDepQuery] = useState("");
	const [totalCount, setTotalCount] = useState(0);
	const [submitParkingSelectionModalToggle, setSubmitParkingSelectionModalToggle] = useState(false);
	const [selectParkingModalToggle, setSelectParkingModalToggle] = useState(false);
	const [selectedAllotments, setSelectedAllotments] = useState([]);
	const [selectedAllotmentForSendTestMail, setSelectedAllotmentForSendTestMail] = useState(null);
	const [selectedAllotmentForSendToLead, setSelectedAllotmentForSendToLead] = useState(null);
	const { showError, AlertModal } = useAlertModal();
	const [selectedAllotmentDataToApprove, setSelectedAllotmentDataToApprove] = useState([]);
	const [selectBtnName, setSelectBtnName] = useState("Select All");
	const [selectedAllotmentForParkingSelection, setSelectedAllotmentForParkingSelection] = useState(null);
	const [crmTimeLineModalToggle, setcrmTimeLineModalToggle] = useState(false);
	const [modalData, setModalData] = useState([]);
	const [leadDisplayId, setLeadDisplayId] = useState("")
	const [virtualAccountStatusModal, setVirtualAccountStatusModal] = useState(false)
	const [allotmentData, setAllotmentData] = useState([])
	const [previewAggrementData, SetPreviewAggrementData] = useState([]);
	const [previewAggrementModalToggle, SetPreviewAggrementModalToggle] = useState(false);
	const isInitialRender = useRef(true);
	const [cancelUnitModal, setCancelUnitModal] = useState(false);
	const [leadObj, setLeadObj] = useState(null);
	const [selectedAllotment, setSelectedAllotment] = useState(null);
	const [viewCostSheet, setViewCostSheet] = useState(false);
	const [reassignCRMModal, setReassignCRMModal] = useState(false);
	const [reassignCRMAllotment, setReassignCRMAllotment] = useState(null);
	const [moveToChangeAVToggle, setMoveToChangeAVToggle] = useState(false);
	const [changeAvAllotment, setChangeAvAllotment] = useState(null);
	const [moveToChangeAVErrorModal, setMoveToChangeAVErrorModal] = useState(false);
	const [moveToChangeAVErrorMessage, setMoveToChangeAVErrorMessage] = useState("");
	const [crmUsers, setCrmUsers] = useState([]);
	const tagGridColumns = [
		{
			field: "action",
			headerName: "",
			// flex: 1,
			// width: showDropDown ? 200 : 160,
			width: 100,
			renderCell: (params) => {
				return (
					<div className={cssClasses.actionDiv}>
						<div>
							<Checkbox
								style={{ width: "2rem", height: "2rem", transform: "scale(2)" }}
								checked={
									selectedAllotments.filter((val) => val?.id === params.id)
										.length > 0
										? true
										: false
								}
								onChange={(e) => {
									const payload = [...selectedAllotments];
									if (e.target.checked) {
										payload.push(params?.row);
										setSelectedAllotments(payload);
										setSelectedAllotmentDataToApprove(payload);
									} else {
										const index = selectedAllotments.findIndex(
											(val) => val?.id === params?.id
										);
										payload.splice(index, 1);
										setSelectedAllotments(payload);
										setSelectedAllotmentDataToApprove(payload);
									}

									if (payload?.length === allCrmAllotments?.length) {
										setSelectBtnName("Remove All");
									} else {
										setSelectBtnName("Select All");
									}
								}}
							/>
							<ThreeDotsMenu
								// list={["Details", "Sync", "Check Status"]}
								// list={[
								//   "Send Test Mail",
								//   "Send Email To Customer",
								//   "View CRM Details",
								// ]}
								list={params.row?.menuOptions}
								selectedValue={(e) => {
									if (e === "Check Virtual Account Status") {
										setLeadDisplayId(params.row?.leaddisplayid)
										setVirtualAccountStatusModal(true)
									}
									if (e === "Send Test Mail") {
										setSelectedAllotmentForSendTestMail(params.row);
									}
									if (e === "Send Email To Customer") {
										setSelectedAllotmentForSendToLead(params.row);
										setSelectedAllotmentDataToApprove([params?.row]);
									}
									if (e === "View Cost Sheet") {
										setSelectedAllotmentForSendToLead(params.row);
										setSelectedAllotmentDataToApprove([params?.row]);
										setViewCostSheet(true);
									}
									if (e === "View CRM Details") {
										setSelectedAllotmentForViewCrmDetails(params.row);
									}
									if (e === "Preview Agreement Confirmation Form") {
										SetPreviewAggrementModalToggle(true);
										SetPreviewAggrementData(params.row);
									}
									if (e === "Timeline And Notes") {
										setAllotmentData(params?.row);
										setcrmTimeLineModalToggle(true);
									}
									if (e === "Cancel Unit") {
										let leadobj = {
											leadId: params.row?.lead_id,
											leadname: params.row?.lead_name,
											leademail: params.row?.lead_email,
											leadcontactnumber: params.row?.bookingformcontactnumber,
											leaddisplayid: params.row?.leaddisplayid.toString(),
										};
										let allotmentObj = {
											allotmentPaymentId: params.row?.allotment_payment_id,
										};
										setLeadObj(leadobj);
										setSelectedAllotment(allotmentObj);
										setCancelUnitModal(true);
									}
									if (e === "Reassign CRM") {
										setReassignCRMAllotment(params?.row);
										setReassignCRMModal(true);
									}
									if (e === "Move to Change AV") {
										setChangeAvAllotment(params?.row);
										setMoveToChangeAVToggle(true);
									}
								}}
							/>
						</div>
					</div>
				);
			},
		},
		{
			field: "unit",
			headerName: "Unit",
			width: 200,
			renderCell: (params) => {
				return (
					<div>
						<div>
							<div>
								{!params?.row?.inventory_merge_id && (
									<span>
										{" "}
										{params?.row?.displaywingname ? params?.row?.displaywingname : params?.row?.wing_name} -{" "}
										{params?.row?.unit_no}{" "}
									</span>
								)}
								{params?.row?.inventory_merge_id && (
									<span>
										{" "}
										{/* {params?.row?.merged_wing_name} -{" "} */}
										{params?.row?.mergeddisplaywingname
											? params?.row?.mergeddisplaywingname
											: params?.row?.merged_wing_name} - {params?.row?.merged_unit_no_one} {"-"}{" "}
										{params?.row?.merged_unit_no_two}{" "}
									</span>
								)}
							</div>
							<div>
								{!params?.row?.inventory_merge_id && <span>{params?.row?.project_name}</span>}
								{params?.row?.inventory_merge_id && <span>{params?.row?.merged_project_name}</span>}
							</div>
						</div>
					</div>
				);
			},
		},
		{
			field: "allotmentId",
			headerName: "Allotment Id",
			width: 200,
			renderCell: (params) => {
				return (
					<Tooltip
						className={classes.Tooltip}
						placement="bottom-start"
						title={
							<div style={{ fontSize: "1.4rem" }}>
								<p>{params.row?.allotment_payment_id}</p>
							</div>
						}
					>
						<div style={{ whiteSpace: "normal", lineBreak: "anywhere" }}>{params.row?.allotment_payment_id}</div>
					</Tooltip>
				);
			},
		},
		{
			field: "leadsDetails",
			headerName: "Leads Name",
			width: 230,
			renderCell: (params) => {
				return (
					<Tooltip
						className={classes.Tooltip}
						placement="bottom-start"
						title={
							<div style={{ fontSize: "1.4rem" }}>
								<p style={{ whiteSpace: "break-spaces" }}>{params.row?.lead_name}</p>
							</div>
						}
					>
						<div>
							<p style={{ whiteSpace: "break-spaces" }}>{params.row?.lead_name}</p>
						</div>
					</Tooltip>
				);
			},
		},
		{
			field: "status",
			headerName: "Email Status",
			flex: 1,
			minWidth: 200,
			renderCell: (params) => {
				return (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							width: "100%",
						}}
					>
						<div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
							<div className={cssClasses.tokenStatus}>
								{params?.row?.isemailsent ? (
									<LeadStatusChip
										label={"Email Sent"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#6941C6",
											backgroundColor: "#F4EBFF",
										}}
									/>
								) : (
									<LeadStatusChip
										label={"Email Not Sent"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#6941C6",
											backgroundColor: "#F4EBFF",
										}}
									/>
								)}
							</div>
						</div>
					</div>
				);
			},
		},
		{
			field: "sdrStatus",
			headerName: "SDR Status",
			flex: 1,
			minWidth: 200,
			renderCell: (params) => {
				return (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							width: "100%",
						}}
					>
						<div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
							<div className={cssClasses.tokenStatus}>
								{!params?.row?.sdrcomplete ? (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									/>
								) : (
									<LeadStatusChip
										label={"SDR Complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "rgb(2, 122, 72)",
											backgroundColor: "rgb(236, 253, 243)",
										}}
									/>
								)}
							</div>
						</div>
					</div>
				);
			},
		},
		{
			field: "event",
			headerName: "Event",
			width: 210,
			renderCell: (params) => {
				return (
					<Tooltip
						className={classes.Tooltip}
						placement="bottom-start"
						title={
							<div style={{ fontSize: "1.4rem" }}>
								<p>{params.row.event_title ? params.row.event_title : "Sustenance"}</p>
							</div>
						}
					>
						<div
							style={{
								textOverflow: "ellipsis",
								overflow: "hidden",
								whiteSpace: "break-spaces",
							}}
						>
							{params.row.event_title ? params.row.event_title : "Sustenance"}
						</div>
					</Tooltip>
				);
			},
		},
		{
			field: "vjSm",
			headerName: "VJ SM",
			width: 160,
			renderCell: (params) => {
				return <div>{params.row.sales_user_name}</div>;
			},
		},
		{
			field: "vjCrm",
			headerName: "VJ CRM",
			width: 180,
			renderCell: (params) => {
				return <div>{params.row.crm_user_name}</div>;
			},
		},
		{
			field: "allotedOn",
			headerName: "Alloted On",
			width: 250,
			renderCell: (params) => {
				return (
					<Tooltip
						className={classes.Tooltip}
						placement="bottom-start"
						title={
							<div style={{ fontSize: "1.4rem" }}>
								<p>
									{new Date(params?.row?.created_at).toDateString()},{" "}
									{new Date(params?.row?.created_at).toLocaleTimeString([], {
										hour: "2-digit",
										minute: "2-digit",
									})}
								</p>
							</div>
						}
					>
						<div>
							<span>
								{new Date(params?.row?.created_at).toDateString()},{" "}
								{new Date(params?.row?.created_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</span>
						</div>
					</Tooltip>
				);
			},
		},
		{
			field: "lastUpdated",
			headerName: "Last Updated",
			width: 270,
			renderCell: (params) => {
				return (
					<Tooltip
						className={classes.Tooltip}
						placement="bottom-start"
						title={
							<div style={{ fontSize: "1.4rem" }}>
								<p>
									{new Date(params?.row?.last_updated_at).toDateString()},{" "}
									{new Date(params?.row?.last_updated_at).toLocaleTimeString([], {
										hour: "2-digit",
										minute: "2-digit",
									})}
								</p>
							</div>
						}
					>
						<div>
							<span>
								{new Date(params?.row?.last_updated_at).toDateString()},{" "}
								{new Date(params?.row?.last_updated_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</span>
						</div>
					</Tooltip>
				);
			},
		},
	];
	const closeCrmModal = () => {
		setcrmTimeLineModalToggle(false);
	};
	useEffect(() => {
		// if (loggedInUser?.isCrmUser && loggedInUser?.id) {
		if (loggedInUser?.id && allCrmAllotments?.length === 0) {
			getCrmAllotmentsFromServer(false);
		}
		getCRMUsersFromUserTable()
			.then((crmUsersRes) => {
				crmUsersRes.data.forEach((ele) => {
					ele.label = ele.name;
					ele.value = ele.name;
				});
				setCrmUsers([...crmUsersRes.data]);
			})
			.catch((err) => {
				console.error(err.message);
			});
	}, [loggedInUser]);

	useEffect(() => {
		if (isInitialRender.current) {
			isInitialRender.current = false;
		} else {
			getCrmAllotmentsFromServer(false);
		}
	}, [filterBy]);


	useEffect(() => {
		let updateUnitListener = supabase
			// .from(`CRM:requestPendingWith=eq.${loggedInUser?.id}`)
			.from(
				`CRM${!loggedInUser?.parentId
					? ""
					: loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
						"Show CRM"
					]?.show === "All"
						? ""
						: `:requestPendingWith=eq.${loggedInUser?.id}`
				}`
			)
			.on("UPDATE", (handleRecordUpdated) => {
				if (
					searchValue.current === "" &&
					filterBy === "Latest First" &&
					checked.length === 0
				) {
					searchValue.current = "";
					pageNumber.current = 0;
					hasMore.current = true;
					getCrmAllotmentsFromServer(false);
				}
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		return () => {
			if (updateUnitListener) {
				supabase.removeSubscription(updateUnitListener);
				updateUnitListener = null;
			}
		};
	}, []);

	useEffect(() => {
		let updateUnitListener = supabase
			.from(`AllotmentPayment`)
			.on("UPDATE", (handleRecordUpdated) => {
				if (
					searchValue.current === "" &&
					filterBy === "Latest First" &&
					checked.length === 0
				) {
					searchValue.current = "";
					pageNumber.current = 0;
					hasMore.current = true;
					getCrmAllotmentsFromServer(false);
				}
			})
			.subscribe((status) => {
				console.log("status: ", status);
			});
		return () => {
			if (updateUnitListener) {
				supabase.removeSubscription(updateUnitListener);
				updateUnitListener = null;
			}
		};
	}, []);

	const closeModal = () => {
		SetPreviewAggrementModalToggle(false);
	};

	async function getFilterAllotmentForDatagrid(nextRange = { from: 0, to: 9 }) {
		let items = await getFilterAllotmentPagination(false, true, nextRange);
		return items;
	}

	async function getFilterAllotmentPagination(
		merge = false,
		isShowSpinner = true,
		nextRange
	) {
		//setAllAllotments([])
		try {
			// const _loggedInUserId = !loggedInUser?.parentId ? null : loggedInUser?.id;
			const _loggedInUserId = !loggedInUser?.parentId
				? null
				: loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[
					"Show CRM"
				]?.show === "All"
					? null
					: loggedInUser?.id;
			const getCrmAllotmentResponse = await getParkingSelectionCrmAllotments(
				_loggedInUserId,
				pageNumber?.current,
				searchValue?.current,
				filterBy,
				checked,
				selectDates,
				nextRange,
				true
			);

			if (getCrmAllotmentResponse.data) {
				// setSelectBtnName("Select All");
				// setSelectedAllotments([]);
				selectBtnName === "Select All" ? setSelectBtnName("Select All") : setSelectBtnName("Remove All");
				selectBtnName === "Remove All" ? setSelectedAllotments(getCrmAllotmentResponse?.data) : setSelectedAllotments([]);

				getCrmAllotmentResponse.data.forEach((crmData) => {
					crmData.menuOptions = [
						"View CRM Details",
						"Timeline And Notes",
						"Check Virtual Account Status"
					];
					if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["Send Email"]?.isAccessible) {
						crmData.menuOptions.push("Send Test Mail")
						crmData.menuOptions.push("Send Email To Customer")
					}
					if (crmData?.is_agreement_form_filled) {
						crmData.menuOptions.push("Preview Agreement Confirmation Form")
					}
					if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["View Cost Sheet"]?.isAccessible) {
						crmData.menuOptions.push("View Cost Sheet");
					}
					if (
						crmData?.status !== "Released" &&
						crmData?.status !== "Change Requested" &&
						crmData?.status !== "Change Rejected" &&
						crmData?.status !== "Cancellation Requested" &&
						crmData?.status !== "Cancellation Rejected" &&
						crmData?.status !== "Cancellation Pending" &&
						crmData?.status !== "Cancellation Not Done" &&
						crmData?.status !== "Cancelled" &&
						// allotment?.status !== "Partial Payment Done" &&
						!crmData?.status.includes("Refund") &&
						(!crmData?.b2b_100_res && !crmData?.gst_b2b_res && !crmData?.sdr_b2b_res)
					) {
						// !!Remaining user access condition
						if (
							loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["CRM"]?.[
								"Cancel Unit"
							]?.isAccessible) {
							crmData.menuOptions.push("Cancel Unit");
						}
					}
					if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["Reassign CRM"]?.isAccessible) {
						crmData.menuOptions.push("Reassign CRM");
					}
					if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["Move to Change AV"]?.isAccessible) {
						crmData.menuOptions.push("Move to Change AV");
					}
					crmData.menuOptions.sort();
				});
				setTotalCount(getCrmAllotmentResponse.count);
				if (getCrmAllotmentResponse.data) {
					setTotalCount(getCrmAllotmentResponse.count);

					if (merge && getCrmAllotmentResponse.data.length) {
						let res = getCrmAllotmentResponse.data;

						if (!merge) {
							setAllCrmAllotments((pre) => [...res]);
							isShowSpinner && dismissLoader();
						} else {
							setAllCrmAllotments((pre) => [...pre, ...res]);
							isShowSpinner && dismissLoader();
						}
					}

					//setFilterOpen(false);
					return getCrmAllotmentResponse.data;
				}
			}
		} catch (err) {
			if (err?.message) {
				errorTost(err?.message);
			} else {
				errorTost("Something went wrong! Try again");
			}
		}
	}

	async function getCrmAllotmentsFromServer(merge, isCheckedClear = false) {
		if (!merge) {
			pageNumber.current = 0;
			hasMore.current = true;
			// setChecked([]);
		}
		mode === "Table View" && setAllCrmAllotments([]);
		const selectedDate = { ...selectDates };
		try {
			presentLoader();
			// const _loggedInUserId = loggedInUser?.id;
			// console.log("Logged In user...", _loggedInUserId);
			// const _loggedInUserId = !loggedInUser?.parentId ? null : loggedInUser?.id;
			// const _loggedInUserId = null;
			const _loggedInUserId = !loggedInUser?.parentId ? null : loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.['Show CRM']?.show === 'All' ? null : loggedInUser?.id;
			await getParkingSelectionCrmAllotments(
				_loggedInUserId,
				pageNumber.current,
				searchValue?.current,
				filterBy,
				checked,
				isCheckedClear ? undefined : selectedDate,
				null,
				null,
				false
			).then((getCrmAllotmentsResponse) => {
				if (getCrmAllotmentsResponse.data) {
					setTotalCount(getCrmAllotmentsResponse.count);
					getCrmAllotmentsResponse.data.forEach((crmData) => {
						crmData.menuOptions = [
							"View CRM Details",
							"Timeline And Notes",
							"Check Virtual Account Status"
						];
						if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["Send Email"]?.isAccessible) {
							crmData.menuOptions.push("Send Test Mail")
							crmData.menuOptions.push("Send Email To Customer")
						}
						if (crmData?.is_agreement_form_filled) {
							crmData.menuOptions.push("Preview Agreement Confirmation Form")
						}
						if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["View Cost Sheet"]?.isAccessible) {
							crmData.menuOptions.push("View Cost Sheet")
						}
						if (
							crmData?.status !== "Released" &&
							crmData?.status !== "Change Requested" &&
							crmData?.status !== "Change Rejected" &&
							crmData?.status !== "Cancellation Requested" &&
							crmData?.status !== "Cancellation Rejected" &&
							crmData?.status !== "Cancellation Pending" &&
							crmData?.status !== "Cancellation Not Done" &&
							crmData?.status !== "Cancelled" &&
							// allotment?.status !== "Partial Payment Done" &&
							!crmData?.status.includes("Refund") &&
							(!crmData?.b2b_100_res && !crmData?.gst_b2b_res && !crmData?.sdr_b2b_res)
						) {
							// !!Remaining user access condition
							if (
								loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.["CRM"]?.[
									"Cancel Unit"
								]?.isAccessible) {
								crmData.menuOptions.push("Cancel Unit");
							}
						}
						if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["Reassign CRM"]?.isAccessible) {
							crmData.menuOptions.push("Reassign CRM");
						}
						if (loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["Move to Change AV"]?.isAccessible) {
							crmData.menuOptions.push("Move to Change AV");
						}
						crmData.menuOptions.sort();
					});
					if (merge) {
						setAllCrmAllotments((pre) => [...pre, ...getCrmAllotmentsResponse.data]);
					} else {
						setAllCrmAllotments([...getCrmAllotmentsResponse.data]);
					}

					if (getCrmAllotmentsResponse.data.length < 10) {
						hasMore.current = false;
					}
					dismissLoader();
				} else {
					throw getCrmAllotmentsResponse;
				}
			}).catch((err) => {
				console.log(err);
				throw err;
			});

			await getParkingSelectionCrmAllotments(
				_loggedInUserId,
				pageNumber.current,
				searchValue?.current,
				filterBy,
				merge ? checked : [],
				isCheckedClear ? undefined : selectedDate,
				null,
				null,
				true
			)
				.then((emailSentData) => {
					setEmailSentCount(emailSentData.data.length);
				})
				.catch((err) => {
					console.log(err);
					throw err;
				});
		} catch (error) {
			if (error?.status === 416) {
				hasMore.current = false;
			} else if (error?.error?.message) {
				errorTost(error?.error?.message);
			} else {
				errorTost("Something went wrong! Try again");
			}
			dismissLoader();
		}
	}

	async function moveLeadToChangeAV(allotment) {
		presentLoader();
		await moveToChangeAVViaApi({
			allotmentPaymentId: allotment?.allotment_payment_id,
			userName: loggedInUser?.name,
			sourceStage: "Parking Selection",
		}).then((res) => {
			dismissLoader();
			if (res?.data?.success) {
				successTost(`Lead ${allotment?.lead_name} moved to Change AV Successfully!`);
				getCrmAllotmentsFromServer(false);
				setMoveToChangeAVToggle(false);
			} else {
				setMoveToChangeAVErrorMessage(res?.data?.message || "Failed to move to Change AV!");
				setMoveToChangeAVErrorModal(true);
				setMoveToChangeAVToggle(false);
			}
		}).catch((err) => {
			console.log("err", err);
			dismissLoader();
			setMoveToChangeAVErrorMessage(err?.response?.data?.message || "Failed to move to Change AV!");
			setMoveToChangeAVErrorModal(true);
			setMoveToChangeAVToggle(false);
		});
	}

	async function sendTestMailHandler(email_id) {
		if (!email_id) {
			errorTost("Email");
			return;
		}
		try {
			presentLoader();
			const sendWelcomePdfResponse = await sendWelcomePdf(
				selectedAllotmentForSendTestMail?.id,
				email_id,
				false
			);
			if (sendWelcomePdfResponse.data?.success) {
				successTost("Email sent successfully.");
			} else {
				throw sendWelcomePdfResponse.data;
			}
			dismissLoader();
			setSelectedAllotmentForSendTestMail(null);
		} catch (error) {
			const msg = error?.error?.message || error?.message || "Could not send email.";
			showError(msg);
			dismissLoader();
			setSelectedAllotmentForSendTestMail(null);
		}
	}

	async function sendMailToLeadHandler(val = null) {
		try {
			presentLoader();
			const sendWelcomePdfResponse = await sendWelcomePdf(
				mode === "Table View" ? val?.id : selectedAllotmentForSendToLead?.id,
				null,
				false
			);
			if (sendWelcomePdfResponse.data?.success) {
				successTost("Email sent successfully to lead.");
				if (!selectedAllotmentForSendToLead?.isemailsent) {
					const crmObj = {
						message: `Welcome email is successfully sent to the ${selectedAllotmentForSendToLead?.lead_name} for allotment unit ${selectedAllotmentForSendToLead?.unit_no} of project ${selectedAllotmentForSendToLead?.project_name}`,
						allotmentPaymentId: selectedAllotmentForSendToLead?.allotment_payment_id,
						crmStatus: "Welcome email sent",
					};
					insertCRMLogs(crmObj)
						.then((res) => {
							console.log("Logs saved", res);
						})
						.catch((err) => {
							console.log(err);
						});
				}
			} else {
				throw sendWelcomePdfResponse.data;
			}
			dismissLoader();
			setSelectedAllotments([]);
			setSelectedAllotmentForSendToLead(null);
		} catch (error) {
			showError(error?.error?.message || "Something went wrong! Try again");
			dismissLoader();
			setSelectedAllotments([]);
			setSelectedAllotmentForSendToLead(null);
		}
	}

	const debouncedFetchSearchData = debounce((e) => {
		searchValue.current = e.target.value;
		pageNumber.current = 0;
		hasMore.current = true;
		getCrmAllotmentsFromServer(false);
	}, 800);

	const allotmentCard = allCrmAllotments.map((allotment, index) => {
		return (
			<Grid className={classes.Grid} item xs={4} sm={4} md={4} lg={4} key={"allotmentCard" + index}>
				<Card className={cssClasses.eventWrap} key={allotment?.id}>
					{/* {allotment?.is_approved && <div className={cssClasses.allotmentApprovedLabel}>Approved</div>} */}
					<div className={cssClasses.cardHeader}>
						<div className={cssClasses.tokenNumWrap}>
							{!allotment?.inventory_merge_id && (
								<span>
									{" "}
									{allotment?.displaywingname ? allotment?.displaywingname : allotment?.wing_name} - {allotment?.unit_no}{" "}
								</span>
							)}
							{allotment?.inventory_merge_id && (
								<span>
									{" "}
									{/* {allotment?.merged_wing_name} -{" "} */}
									{allotment?.mergeddisplaywingname ? allotment?.mergeddisplaywingname : allotment?.merged_wing_name} -{" "}
									{allotment?.merged_unit_no_one} {"-"} {allotment?.merged_unit_no_two}{" "}
								</span>
							)}
							<span>|</span>
							{!allotment?.inventory_merge_id && <span>{allotment?.project_name}</span>}
							{allotment?.inventory_merge_id && <span>{allotment?.merged_project_name}</span>}
						</div>
						{allotment?.unitof && <div><LeadStatusChip
							label={allotment?.unitof}
							style={{
								color: "#3538CD",
								backgroundColor: "#EEF4FF",
							}}
						/></div>}
					</div>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							width: "100%",
						}}
					>
						<div className={cssClasses.chipWrapper}>
							{/* SDR Status */}
							<div className={cssClasses.tokenStatus}>
								{!allotment?.sdrcomplete && (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
									/>
								)}
								{allotment?.sdrcomplete && (
									<LeadStatusChip
										label={"SDR Complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
									/>
								)}
							</div>
							{/* AV Status */}
							<div className={cssClasses.tokenStatus}>
								{!allotment?.is_changeable_value && (
									<LeadStatusChip
										label={"AV Not Changed"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
									/>
								)}
								{allotment?.is_changeable_value && (
									<LeadStatusChip
										label={"AV Changed"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
									/>
								)}
							</div>
							{/* Agreement KYC Status */}
							<div className={cssClasses.tokenStatus}>
								{!allotment?.is_agreement_form_filled && (
									<LeadStatusChip
										label={"Agreement KYC Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
									/>
								)}
								{allotment?.is_agreement_form_filled && (
									<LeadStatusChip
										label={"Agreement KYC Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
									/>
								)}
							</div>
							{/* OCR Status */}
							<div className={cssClasses.tokenStatus}>
								{allotment?.isocrgreater === "less" ?
									(<LeadStatusChip
										label={"OCR < 10%"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
									/>
									) :
									(allotment?.isocrgreater === "equal" ?
										(<LeadStatusChip
											label={"OCR = 10%"}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
										/>) :
										(<LeadStatusChip
											label={"OCR > 10%"}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
										/>
										))}
							</div>
							<div className={cssClasses.tokenStatus}>
								{allotment?.isemailsent && (
									<LeadStatusChip
										label={"Email Sent"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#6941C6", backgroundColor: "#F4EBFF" }}
									/>
								)}
							</div>
						</div>
						<div className={cssClasses.tokenActions}>
							<ThreeDotsMenu
								list={allotment?.menuOptions}
								selectedValue={(e) => {
									if (e === "Check Virtual Account Status") {
										setLeadDisplayId(allotment.leaddisplayid)
										setVirtualAccountStatusModal(true)
									}
									if (e === "Send Test Mail") {
										setSelectedAllotmentForSendTestMail(allotment);
									}
									if (e === "Send Email To Customer") {
										// selectedAllotmentObject?.crmUserId?.crmUserDocUrl   == crm_user_doc_url
										let _allotment = {
											...allotment,
											crmUserId: {
												crmUserDocUrl: allotment.crm_user_doc_url,
											},
										};
										setSelectedAllotmentForSendToLead(_allotment);
									}
									if (e === "View Cost Sheet") {
										let _allotment = {
											...allotment,
											crmUserId: {
												crmUserDocUrl: allotment.crm_user_doc_url,
											},
										};
										setSelectedAllotmentForSendToLead(_allotment);
										setViewCostSheet(true);
									}
									if (e === "View CRM Details") {
										let _allotment = {
											...allotment,
											allotmentPaymentId: {
												paidAmt: allotment.paidamt,
												unitCost: allotment.unitcost,
												allotmentPaymentId: allotment.allotment_payment_id,
												applicationApiRes: allotment?.application_api_res,
												"100AmrRes": allotment?.amr_100_res,
												"100B2bRes": allotment?.b2b_100_res,
												GstAmrRes: allotment?.gst_amr_res,
												gstB2bRes: allotment?.gst_b2b_res,
												SdrB2bRes: allotment?.sdr_b2b_res,
												WithoutTdsRes: allotment?.without_tds_res,
											},
										};
										setSelectedAllotmentForViewCrmDetails(_allotment);
									}
									if (e === "Timeline And Notes") {
										setAllotmentData(allotment)
										setcrmTimeLineModalToggle(true);
									}
									if (e === "Preview Agreement Confirmation Form") {
										SetPreviewAggrementModalToggle(true);
										SetPreviewAggrementData(allotment);
									}
									if (e === "Cancel Unit") {
										let leadobj = {
											leadId: allotment?.lead_id,
											leadname: allotment?.lead_name,
											leademail: allotment?.lead_email,
											leadcontactnumber: allotment?.bookingformcontactnumber,
											leaddisplayid: allotment?.leaddisplayid.toString(),
										};
										let allotmentObj = {
											allotmentPaymentId: allotment?.allotment_payment_id,
										};
										setLeadObj(leadobj);
										setSelectedAllotment(allotmentObj);
										setCancelUnitModal(true);
									}
									if (e === "Reassign CRM") {
										setReassignCRMAllotment(allotment);
										setReassignCRMModal(true);
									}
									if (e === "Move to Change AV") {
										setChangeAvAllotment(allotment);
										setMoveToChangeAVToggle(true);
									}
								}}
							/>
						</div>
					</div>
					<div className={cssClasses.leadDetailsDiv} style={{ flexDirection: "column" }}>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
							}}
						>
							<div className={cssClasses.tokenNumWrap} style={{ alignItems: "baseline" }}>
								<p>{allotment?.lead_name}</p>
								<p
									style={{
										fontFamily: "Inter-Regular",
										fontStyle: "normal",
										fontWeight: 400,
										fontSize: "1.4rem",
										lineHeight: "1.8rem",
										color: "#667085",
									}}
								>
									{"VJ" +
										allotment?.leaddisplayid
											?.toString()
											?.replace(
												allotment?.leaddisplayid?.toString()?.substring(8, 12),
												"-" + allotment?.leaddisplayid?.toString()?.substring(8, 12)
											)}
								</p>
							</div>
							<div
								className={cssClasses.allotmentPaymentId}
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
								}}
							>
								<p>+{allotment?.bookingformcontactnumber}</p>
								<a
									href={`tel:+${allotment?.bookingformcontactnumber}`}
									data-action="share/whatsapp/share"
									target="_blank"
									rel="noopener noreferrer"
								>
									<CallIcon style={{ width: "3rem", height: "3rem" }} round={true} />
								</a>
							</div>
						</div>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								width: "100%",
							}}
						>
							<p style={{ color: "darkgray", fontSize: "1.4rem" }}>{allotment?.allotment_payment_id}</p>
						</div>
						<div style={{
							display: "flex",
							gap: "1rem",
							justifyContent: "space-between",
							marginTop: "1rem",
							width: "100%",
							flexDirection: "row"
						}}>
							{/* <div
								style={{
									display: "flex",
									gap: "1rem",
									justifyContent: "start",
								}}
							>
								{allotment?.leadvjop && <div><LeadStatusChip
									label="VJOP"
									style={{
										color: "rgb(180, 35, 24)",
										backgroundColor: "rgb(254, 243, 242)",
									}}
								/></div>}
							</div> */}

							 <div
											style={{
											  display: "flex",
											  gap: "1rem",
											  justifyContent: "start",
											}}
										  >
											{/* {allotment?.leadvjop && <div><LeadStatusChip
															label="VJOP"
															style={{
															  color: "rgb(180, 35, 24)",
															  backgroundColor: "rgb(254, 243, 242)",
															}}
														  /></div>} */}
											{allotment?.leadvjop ? (
											  allotment?.leadsubtype?.trim?.().toLowerCase?.() === "loyalty" ? (
												<LeadStatusChip
												  label="VJOP-LOYALTY"
												  style={{
													color: "rgb(180, 35, 24)",
													backgroundColor: "rgb(254, 243, 242)",
													fontSize: "0.85rem",
													minWidth: "140px",
													textAlign: "center",
												  }}
												/>
											  ) : (
												<LeadStatusChip
												  label="VJOP"
												  style={{
													color: "rgb(180, 35, 24)",
													backgroundColor: "rgb(254, 243, 242)",
													fontSize: "0.85rem",
													minWidth: "140px",
													textAlign: "center",
												  }}
												/>
											  )
											) : (
											  allotment?.leadtype && (
												<LeadStatusChip
												  label={allotment.leadtype}
												  style={{
													color: "rgb(24, 90, 180)",
													backgroundColor: "rgb(240, 247, 255)",
													fontSize: "0.85rem",
													minWidth: "140px",
													textAlign: "center",
												  }}
												/>
											  )
											)}
										  </div>


							<div
								style={{
									display: "flex",
									gap: "1rem",
									justifyContent: "end",
								}}
							>
								{allotment?.isdiscountapplied ? (
									<LeadStatusChip
										label={"Discount Applied"}
										style={{ color: "#234a2e", backgroundColor: "#b8e6c4" }}
									></LeadStatusChip>)
									: (allotment?.isdiscounteligible &&
										<LeadStatusChip
											label={"Discount Eligible"}
											style={{
												color: "#FF4F00",
												backgroundColor: "#fad5be",
											}}
										></LeadStatusChip>
									)}
							</div>
						</div>
					</div>
					<div className={cssClasses.cardDetails}>
						<div className={cssClasses.tokenDetails}>
							<div className={cssClasses.tokenData} style={{ justifyContent: "space-between" }}>
								<span> {allotment?.event_title ? allotment?.event_title : "Sustenance "} </span>
								{allotment?.event_title && allotment?.pricing_type === "preselect" && (
									<span>
										<LeadStatusChip
											label={"Preselect"}
											style={{
												color: "#3538CD",
												backgroundColor: "#EEF4FF",
											}}
										/>
									</span>
								)}
								<div className={cssClasses.tokenLastUpdate}>
									<ReactTimeAgo
										style={{ fontSize: "1.2rem" }}
										date={allotment?.last_updated_at ?? allotment?.created_at}
										locale="en-US"
									/>
								</div>
							</div>
							<div className={cssClasses.tokenData} style={{ justifyContent: "space-between" }}>
								<div className={cssClasses.tokenLastUpdate} style={{ flex: 1 }}>
									<p>VJ SM - {allotment?.sales_user_name}</p>
									{/* <p>VJ SM - {allotment.cpbillingname}</p> */}
									{/* { allotment?.allotmentPaymentId?.crmuserid && allotment?.allotmentPaymentId?.crmusername && <p>VJ CRM - {allotment?.allotmentPaymentId?.crmusername}</p>} */}
									{allotment?.crm_user_name && allotment?.crm_user_name && <p>VJ CRM - {allotment?.crm_user_name}</p>}
								</div>
							</div>
							<div className={cssClasses.tokenData} style={{ justifyContent: "space-between" }}>
								<div>
									{allotment?.display_inventory_type?.includes("Inventory Type") && <span>{allotment?.inventory_type}</span>}
									{allotment?.display_inventory_type?.includes("Display Unit Type") && (
										<span>{"(" + allotment?.display_unit_type + ")"}</span>
									)}
									{!allotment?.inventory_type && <span>Merged</span>}
								</div>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									width: "100%",
								}}
							>
								<div>
									<span>Alloted By: </span>
									<span>{allotment?.allotedbyuser}</span>
								</div>
								<div>
									<span>Alloted On: </span>
									<span>
										{new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toDateString()},{" "}
										{new Date(allotment?.preselectconfirmationdate ?? allotment?.created_at).toLocaleTimeString([], {
											hour: "2-digit",
											minute: "2-digit",
										})}
									</span>
								</div>
							</div>
						</div>
					</div>
					{allotment?.paymentplantitle &&
						<div style={{
							display: "flex",
							gap: "1rem",
							width: "100%",
							fontSize: "1.4rem",
							color: "rgba(220, 104, 3, 1)",
						}}>
							<span style={{ textTransform: "capitalize" }}>Payment Plan {allotment?.paymentplantitle} is selected.</span>
						</div>}
					{(allotment?.is_change_applicant_raised === false && allotment?.change_applicant_status === "pending")
						? (
							<div
								style={{
									display: "flex",
									gap: "1rem",
									width: "100%",
									fontSize: "1.4rem",
									padding: "10px 0",
									color: "rgba(179, 35, 24, 1)",
								}}
							>
								<img src={infoSvg} alt="info" />
								<span>
									Change applicant request is pending.
								</span>
							</div>
						)
						: (allotment?.is_change_applicant_raised === false && allotment?.change_applicant_status === null) && (
							<div
								style={{
									display: "flex",
									gap: "1rem",
									width: "100%",
									fontSize: "1.4rem",
									padding: "10px 0",
									color: "rgba(179, 35, 24, 1)",
								}}
							>
								<img src={infoSvg} alt="info" />
								<span>
									Changed applicant is in process.
								</span>
							</div>
						)
					}

					<div className={cssClasses.cardFooter}>
						{(loggedInUser?.roleId?.level == 1 ||
							loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.["Parking Selection"]?.["Select Parking"]?.isAccessible) &&
							<CardActions
								style={{
									width: "100%",
									display: "flex",
									flexDirection: "row",
									justifyContent: "end",
									padding: 0,
								}}
							>
								<div className={cssClasses.tokenStatus}>
									<Button
										style={{
											color: "#fff",
											backgroundColor: "#006AFF",
											fontSize: "1.4rem",
											lineHeight: "2rem",
											fontFamily: "Inter-Medium !important",
										}}
										btnName={"Select Parking"}
										clicked={() => {
											// setCurrentAllotmentData({...allotment})
											// setSubmitParkingSelectionModalToggle(true);
											// onParkingSelectionSubmit(allotment);
											setSelectedAllotmentForParkingSelection(allotment);
											setSelectParkingModalToggle(true);
										}}
										disable={allotment?.is_change_applicant_raised === false}
									/>
								</div>
							</CardActions>}
					</div>
				</Card>
			</Grid>
		);
	});

	const handleAllSelect = () => {
		if (selectBtnName === "Select All") {
			setSelectBtnName("Remove All");
			setSelectedAllotmentDataToApprove(allCrmAllotments);
			setSelectedAllotments(allCrmAllotments);
		} else {
			setSelectBtnName("Select All");
			setSelectedAllotments([]);
		}
	};

	return (
		<>
			<div className={cssClasses.content}>
				<div
					className={cssClasses.actionWrapper}
					style={{ justifyContent: "space-between", alignItems: "center" }}
				>
					<div className={cssClasses.countWrapper}>
						<p>{totalCount} Parking Selection</p>
						<p>{emailSentCount} Total Email Sent</p>
					</div>
					<div className={cssClasses.filterContainer}>
						<div className={cssClasses?.filterWrapper}>
							{/* start filter implements */}
							<AllotmentFilter
								depStr={depStr}
								setDepQuery={setDepQuery}
								checked={checked}
								setChecked={setChecked}
								hasMore={hasMore}
								selectDates={selectDates}
								setSelectDates={setSelectDates}
								setAllCrmAllotments={setAllCrmAllotments}
								getCrmAllotmentsFromServer={getCrmAllotmentsFromServer}
								_loggedInUserId={null}
								pageNumber={pageNumber}
							/>

							{/* end filter implements */}
							<AllotmentSortFilter
								filterBy={filterBy}
								setFilterBy={setFilterBy}
								allCrmAllotments={allCrmAllotments}
								setAllCrmAllotments={setAllCrmAllotments}
							/>
							{/* <ViewToggleSwitch setMode={setMode} /> */}
						</div>
						<div
							className={cssClasses.searchWrapper}
							style={{ display: "flex", alignItems: "center", gap: "15px" }}
						>
							{mode === "Table View" && (
								<Button
									style={{
										color: "#fff",
										backgroundColor: "#006AFF",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										fontFamily: "Inter-Medium !important",
										width: "21rem",
									}}
									btnName={"Send Mail to Customer"}
									disable={selectedAllotments?.length === 0}
									clicked={() => {
										setSelectedAllotmentForSendToLead(true);
									}}
								/>
							)}
							<SearchBar
								width="254px"
								sxStyle={{
									"& input": {
										fontSize: "1.3rem !important",
										fontFamily: "Inter-Medium !important",
									},
								}}
								placeholder={"Search by Lead Name Or Unit No"}
								search={debouncedFetchSearchData}
								id={"tagPendingCrmAllotmentLeadName"}
							/>
						</div>
					</div>
				</div>

				{allCrmAllotments.length > 0 ? (
					<>
						{mode === "Card View" && (
							<Box id="scrollableDiv" className={cssClasses.mainTabPanelWrapper}>
								<Box sx={{ flexGrow: 1 }}>
									<InfiniteScroll
										dataLength={allCrmAllotments.length}
										next={() => {
											if (hasMore.current) {
												pageNumber.current = pageNumber.current + 1;
												getCrmAllotmentsFromServer(true);
											}
										}}
										style={{
											display: "flex",
											flexDirection: "column",
											overflowY: "auto",
										}} //To put endMessage and loader to the top.
										hasMore={hasMore}
										// loader={<p className={cssClasses.infiniteScrollLoadingText}>Loading...</p>}
										scrollableTarget="scrollableDiv"
									>
										<Grid
											style={{
												marginTop: "0rem",
												marginBottom: "1rem",
												marginLeft: "0rem",
												width: "100%",
											}}
											container
											spacing={{ xs: 2, md: 3, lg: 3 }}
											columns={{ xs: 4, sm: 4, md: 8, lg: 8 }}
										>
											{allotmentCard}
										</Grid>
									</InfiniteScroll>
								</Box>
							</Box>
						)}

						{mode === "Table View" && (
							<div className={cssClasses.tableContainer}>
								<div
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<label style={{ fontSize: "1.6rem" }}>
										{/* {selectedAllotments?.length} Tags Selected */}
										{selectBtnName === "Remove All" ? totalCount : selectedAllotments?.length} Tags Selected
									</label>
									<Button
										btnName={selectBtnName}
										style={{
											color: "#fff",
											width: "150px",
											backgroundColor: "#006AFF",
											fontSize: "1.4rem",
											lineHeight: "2rem",
											fontFamily: "Inter-Medium !important",
										}}
										clicked={() => {
											handleAllSelect();
										}}
									/>
								</div>
								<ServerPaginationGrid
									sx={{
										"& .MuiDataGrid-columnHeaders + div": {
											height: "calc(100vh - 440px) !important",
										},
									}}
									name="crm-parking-selection"
									rows={allCrmAllotments}
									columns={tagGridColumns}
									depStr={depStr}
									count={totalCount}
									getDataByPage={getFilterAllotmentForDatagrid}
								/>
							</div>
						)}
					</>
				) : (
					<div style={{ height: "100%" }}>
						<p
							style={{
								position: "relative",
								top: "50%",
								transform: "translateY(-50%)",
								textAlign: "center",
								fontSize: "3rem",
							}}
						>
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
								}}
							>
								<img src={EmptyState} alt="No Data" />
								<span>No Allotment Available</span>
							</div>
						</p>
					</div>
				)}
			</div>
			{/* Select Parking Modal */}
			{selectParkingModalToggle && <SelectParkingModal
				open={true}
				handleClose={() => {
					setSelectParkingModalToggle(false);
				}}
				allotment={selectedAllotmentForParkingSelection}
				getCrmAllotmentsFromServer={getCrmAllotmentsFromServer}
			/>}
			{/*View CRM Details Modal */}
			{selectedAllotmentForViewCrmDetails && (
				<ViewAllotedCrmDetailsModal
					selectedAllotmentObject={selectedAllotmentForViewCrmDetails}
					open={Boolean(selectedAllotmentForViewCrmDetails)}
					handleClose={(_result) => {
						setSelectedAllotmentForViewCrmDetails(null);
					}}
				/>
			)}
			{/* Send mail to Customer */}
			{selectedAllotmentForSendToLead && (
				<ViewDocumentsModal
					selectedAllotmentObject={selectedAllotmentForSendToLead}
					open={Boolean(selectedAllotmentForSendToLead)}
					handleClose={(_result) => {
						setSelectedAllotments([]);
						setSelectedAllotmentForSendToLead(null);
						setViewCostSheet(false)
					}}
					sendMailToLead={() => {
						if (mode === "Table View") {
							selectedAllotmentDataToApprove.map((val, index) =>
								sendMailToLeadHandler(val)
							);
						} else {
							sendMailToLeadHandler();
						}
					}}
					isTableView={mode === "Table View" ? true : false}
					allotmentTableData={selectedAllotmentDataToApprove}
					isCompleteTab
					viewCostSheet={viewCostSheet}
				/>
			)}
			{AlertModal}

			{/* Enter Email Modal */}
			{selectedAllotmentForSendTestMail && (
				<EnterEmailModal
					open={Boolean(selectedAllotmentForSendTestMail)}
					handleClose={(_result) => {
						if (_result?.flag) {
							sendTestMailHandler(_result?.email);
						} else {
							setSelectedAllotmentForSendTestMail(null);
						}
					}}
				/>
			)}
			{previewAggrementModalToggle && (
				<PreviewAggrementConfirmationModal
					open={true}
					handleClose={closeModal}
					allotment={previewAggrementData}
					tabName={"Parking Selection"}
				/>
			)}
			{crmTimeLineModalToggle && (
				<CrmTimeLineModal
					open={true}
					data={allotmentData}
					handleClose={closeCrmModal}
				/>
			)}
			{virtualAccountStatusModal && (
				<UpdateLeadDetails open={virtualAccountStatusModal}
					handleClose={() => {
						setVirtualAccountStatusModal(false);
					}}
					leadDisplayId={leadDisplayId}
				/>
			)}
			{cancelUnitModal && (
				<CancelUnit
					open={cancelUnitModal}
					handleClose={() => {
						setCancelUnitModal(false);
					}}
					data={leadObj}
					returnRes={(value) => {
						if (value) {
							dismissLoader();
							successTost("Cancellation done successfully!");
						}
					}}
					selectedAllotmentPass={selectedAllotment}
				/>
			)}
			{reassignCRMModal && (
				<SelectCrmUserModal
					open={reassignCRMModal}
					crmUsersList={crmUsers}
					handleClose={() => { setReassignCRMModal(false) }}
					heading={"Reassign CRM"}
					allotment={reassignCRMAllotment}
				/>
			)}
			{moveToChangeAVToggle && (
				<ConfirmationAlert
					confirm={(e) => {
						if (e === "confirmed") {
							moveLeadToChangeAV(changeAvAllotment);
						}
					}}
					buttonTitle={"Cancel"}
					returnRespButton={"Confirm"}
					close={() => {
						setMoveToChangeAVToggle(false);
						setChangeAvAllotment(null);
					}}
					title={"Warning"}
					subTitle={`Are you sure! Do you want to move ${changeAvAllotment?.lead_name} to Change AV tab?`}
					open={moveToChangeAVToggle}
				/>
			)}
			{moveToChangeAVErrorModal && (
				<ConfirmationAlert
					confirm={() => setMoveToChangeAVErrorModal(false)}
					returnRespButton={"OK"}
					close={() => setMoveToChangeAVErrorModal(false)}
					title={"Unable to Move to Change AV"}
					subTitle={moveToChangeAVErrorMessage}
					open={moveToChangeAVErrorModal}
				/>
			)}
		</>
	);
}

export default ParkingSelection;

function numberWithCommas(x) {
	return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}